export default __webpack_public_path__ + "static/media/add-payment-icon.5f3cbb98.svg";